export default "__VITE_ASSET__e4b19b9f__"